<template>
  <m-layout-mask>
    <m-layout class="left-sidebar-layout" :class="{ compact: compactSidebar }" :style="{ width: !compactSidebar ? 240 + 'px' : 0 + 'px' }">
    <!--m-layout class="left-sidebar-layout" :class="{ compact: compactSidebar }"-->
      <m-scrollbar :key="isActive('page', 'main') + isActive('page', 'sports') + isActive('page', 'upcoming') + $i18n.locale + this.$route.path + this.hours">
        <time-filter :hours="hours" :suite="[ 0, 1, 3, 6, 12, 24, 48 ]" @change="changeTimeFilterValue" v-if="!isActive('page', 'live') && !isActive('page', 'upcoming')" />
        <time-filter :hours="hours" :suite="[ 0, 1, 3, 6, 12, 24, 48 ]" @change="changeTimeFilterValueNew" v-if="isActive('page', 'upcoming')" />
        <!--search v-if="!isActive('page', 'upcoming')" /-->
        <!--m-widget-head class="sports-widget-head">
          <template slot="right">
            <m-hide-toggler :compact="compactSidebar" @toggle="compactSidebar = arguments[0]" />
            <span class="but" @click="isLineMenu()" v-bind:class="{ active: isLive }" :key="isLive">{{ $t('menu.live') }}</span>
            <span class="but" @click="isLineMenu()" v-bind:class="{ active: isLine }" :key="isLine">{{ $t('menu.sports') }}</span>
          </template>
        </m-widget-head-->
        <!--popular-menu style="margin-top: 0px; margin-bottom: -15px; margin-left: 5px;" v-if="(isActive('page', 'main') || isActive('page', 'sports')) && !isActive('page', 'upcoming')"/-->
        <live-menu v-if="isActive('page', 'live') && !isActive('page', 'upcoming')"/>
        <sports-menu v-if="(isActive('page', 'main') || isActive('page', 'sports')) && !isActive('page', 'upcoming')"/>
        <!--upcoming-menu v-if="isActive('page', 'upcoming')" /-->
      </m-scrollbar>
    </m-layout>
    <m-layout grow style="width: 750px;">
      <router-view />
    </m-layout>
  </m-layout-mask>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MLayout from '@/components/layouts/MLayout'
import MScrollbar from '@/components/MScrollbar'
import MWidgetHead from '@/components/widget/MWidgetHead'
import MHideToggler from '@/components/buttons/MHideToggler'
import PopularMenu from '@/components/sports/menu/Popular'
import SportsMenu from '@/components/sports/menu/Menu'
import LiveMenu from '@/components/live/menu/Menu'
import UpcomingMenu from '@/components/live/upcoming/Menu'
import Search from '@/components/header/Search'
import TimeFilter from '@/components/TimeFilter'
import { mapState } from 'vuex'

export default {
  components: { MLayoutMask, MLayout, MScrollbar, MWidgetHead, MHideToggler, PopularMenu, SportsMenu, LiveMenu, UpcomingMenu, TimeFilter, Search },
  data () {
    return {
      compactSidebar: false,
      isLine: true,
      isLive: false,
      width: 0
    }
  },
  computed: {
    ...mapState({
      hours: state => state.prematch.timeFilterValue,
      loading: state => state.prematch.loader.loading,
      scrollLoading: state => state.prematch.loader.scrollLoading,
      isTopLoader: state => state.prematch.loader.top,
      screenTop: state => state.prematch.screen.top,
      screenBottom: state => state.prematch.screen.bottom
    })
  },
  mounted () {
    /* let view = document.querySelector('#prematch-matches-scrollbar')
    view.scrollTop = 0
    this.clientHeight = view.clientHeight */
    this.onResize()
    window.addEventListener('resize', this.onResize)
    this.$on('hook:beforeDestroy', () => window.removeEventListener('resize', this.onResize))
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.$store.dispatch('prematch/GET_MENU_SPORTS')
    }
  },
  methods: {
    isLineMenu () {
      if (this.isLine) {
        this.isLine = false
        this.isLive = true
      } else if (this.isLive) {
        this.isLine = true
        this.isLive = false
      }
    },
    onResize () {
      this.width = window.innerWidth
    },
    changeTimeFilterValue (hours) {
      this.$store.commit('prematch/SET_TIME_FILTER_VALUE', hours)
      let view = document.querySelector('#prematch-matches-scrollbar')
      view.scrollTop = 0
      this.scrollTop = 0
      this.$store.commit('prematch/SET_LOADER_POSITION', 'top')
      this.$store.dispatch('prematch/GET_MATCHES', {
        params: Object.assign({
          top: this.scrollTop,
          height: view.clientHeight
        }, this.$route.params)
      })
      this.$store.dispatch('prematch/GET_MENU_SPORTS')
    },
    changeTimeFilterValueNew (hours) {
      this.$store.commit('live/SET_UPCOMING_TIME_FILTER_VALUE', hours)
      this.$store.dispatch('live/GET_UPCOMING')
    }
  }
}
</script>

<style scoped>
.sports-widget-head { margin-left: 10px; }
.hidden { display: none; }
.active { background: #126e51; }
.but { width: 50%;
    text-align: center;
    margin-top: 9px;
    border: 1px solid gray;
    margin-right: 10px;
    line-height: 27px;
    margin-left: -4px;
    cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/components/sports/Sports.vue